import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { AccountShell, GoogleButton } from "@/components/account";
import { useSeo } from "@/lib/seo";

export default function Login() {
  useSeo({ title: "Sign in", path: "/login", noindex: true });
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      toast.success("Signed in");
      navigate(u.role === "tester" ? "/tester" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not sign in");
    } finally {
      setBusy(false);
    }
  }

  return (
    <AccountShell title="Welcome back" subtitle="Sign in to see your jobs, reports and credit.">
      <GoogleButton label="Continue with Google" role="client" />
      <div className="auth-or"><span>or</span></div>
      <form onSubmit={submit}>
        <div className="field"><label htmlFor="login-email">Email</label>
          <input id="login-email" data-testid="login-email" type="email" autoComplete="email" required
            value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" /></div>
        <div className="field"><label htmlFor="login-password">Password</label>
          <input id="login-password" data-testid="login-password" type="password" autoComplete="current-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" /></div>
        <button className="btn blue auth-submit" data-testid="login-submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="auth-foot small"><Link to="/forgot-password" data-testid="login-forgot">Forgot password?</Link></p>
      <p className="auth-foot small">New to 99tests? <Link to="/signup" data-testid="login-to-signup">Create an account</Link></p>
    </AccountShell>
  );
}
